import { ReactNode } from 'react';

import { FileTextIcon } from 'lucide-react';

import { env } from '@/constants/env';
import { cn } from '@/lib/utils';

import { ACCEPTED_MEDIA_TYPES } from '../schema/upload-media';

type MediaIageProps = {
  mediaId: string;
  fileName?: string;
  fileType?: string | null;
  isRounded?: boolean;
};

export const MediaPicture = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex aspect-square items-center justify-center overflow-hidden bg-secondary text-primary-light">
      {children}
    </div>
  );
};

export const MediaImage = ({ mediaId, fileName, fileType, isRounded }: MediaIageProps) => {
  return (
    <div className={cn('aspect-square overflow-hidden', isRounded && 'rounded-md')}>
      {fileType === ACCEPTED_MEDIA_TYPES.Pdf ? (
        <MediaPicture>
          <FileTextIcon size={40} />
        </MediaPicture>
      ) : (
        <img
          className="size-full object-cover"
          src={`${env.API_URL}/images/${mediaId}`}
          alt={fileName}
        />
      )}
    </div>
  );
};
